/** The editor route for a draft. */
export function draftUrl(storyId: string): string {
  return `/drafts/${encodeURIComponent(storyId)}/canvas`
}

/**
 * What the "Write" button means: keep writing. Opens the most recently edited draft, or — for a
 * writer who has none yet — creates one and drops them on the story-start chooser, which is what
 * a fresh story renders. It used to send them to the My Stories list instead, which for that
 * writer is an empty page with no way back into the editor.
 */
export async function startWriting(): Promise<void> {
  const stories = await window.api.stories.list()
  const latest = [...stories].sort((a, b) => b.updatedAt - a.updatedAt)[0]
  const target = latest ?? (await window.api.stories.create('Untitled Story'))
  window.location.href = draftUrl(target.id)
}
